<template>
  <div :class="solution||productCategory?'my-top-menu':''">
        <Row>
            <Col span="2"></Col>
            <Col span="4">
              <div :style="solution||productCategory?'display: none;':'padding: 0.2rem 0.5rem 0 0.5rem;'">
                <img src="../../assets/img/th-top.png" style="width: 2rem;" v-if="this.scroll===true">
                <img src="../../assets/img/top-logo2.png" style="width: 2rem;" v-else>
              </div>
			  <div :style="solution||productCategory?'padding: 0.2rem 0.5rem 0 0.5rem;':'display: none;'">
			    <img src="../../assets/img/top-logo2.png" style="width: 2rem;">
			  </div>
            </Col>
            <Col span="16" style='text-align:right;'>
              <div class="top-menu-content">
                 <Menu mode="horizontal" :theme="theme1" :active-name="index">
                        <MenuItem name="1" to="home" >
                          <div @click="resetSetItem('index','1')">
                            首页
                          </div>
                        </MenuItem>
                        <MenuItem name="2" to="solution">
                          <div @click="resetSetItem('index','2')" @mouseover="solution=true" @mouseout="solution=false">
                            解决方案
                          </div>
                        </MenuItem>
                        <MenuItem name="3" to="productCenter">
                          <div @click="resetSetItem('index','3')" @mouseover="productCategory=true" @mouseout="productCategory=false">
                            产品中心
                          </div>
                        </MenuItem>
                        <MenuItem name="4" to="CoreServices">
                          <div @click="resetSetItem('index','4')">
                            咨询服务
                          </div>
                        </MenuItem>
                        <MenuItem name="5" to="successCase">
                          <div @click="resetSetItem('index','5')">
                            成功案例
                          </div>
                        </MenuItem>
                        <MenuItem name="6" to="productDemo">
                          <div @click="resetSetItem('index','6')">
                            产品演示
                          </div>
                        </MenuItem>
                        <MenuItem name="7" to="aboutMe">
                          <div @click="resetSetItem('index','7')">
                            关于我们
                          </div>
                        </MenuItem>
                    </Menu>
              </div>
            </Col>
			<Col span="2"></Col>
        </Row>
		<div class="productCategory" :style="solution?'opacity:1':'opacity:0;display: none;'" @mouseover="solution=true" @mouseout="solution=false">
			<Row>
				<Col span="4" style="background: #ffffff;"></Col>
				<Col span="20">
					<Row>
						<Col span="5">
							<div class="chemicalMaterials">
								  <p :style="solutionCategory==1?'color: #009bff;':''" @click="solutionCategory=1">企业</p>
								<p class="chemicalMaterials-p" :style="solutionCategory==2?'color: #009bff;':''" @click="solutionCategory=2">政府机构</p>
								<p class="chemicalMaterials-p" :style="solutionCategory==3?'color: #009bff;':''" @click="solutionCategory=3">教育</p>
								<p class="chemicalMaterials-p" :style="solutionCategory==4?'color: #009bff;':''" @click="solutionCategory=4">医疗</p>
							</div>
						</Col>
						<Col span="19">
							<div class="second-productCategory">
								<div class="second-solutionCategory-con" :style="solutionCategory==1?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:1}}">
									<p class="solutionCategory-p" @click="solution=false">本地化物联网平台解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==2?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:3}}">
									<p class="solutionCategory-p" @click="solution=false">信息安全生态解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==2?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:10}}">
									<p class="solutionCategory-p" @click="solution=false">智慧社区解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==3?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:0}}">
									<p class="solutionCategory-p" @click="solution=false">极简以太全光解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==3?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:8}}">
									<p class="solutionCategory-p" @click="solution=false">智慧校园解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==4?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:9}}">
									<p class="solutionCategory-p" @click="solution=false">智慧医疗解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==1?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:2}}">
									<p class="solutionCategory-p" @click="solution=false">智慧园区解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==2?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:6}}">
									<p @click="solution=false">政务一体化安全解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==2?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:11}}">
									<p class="solutionCategory-p" @click="solution=false">智慧景区解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==3?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:4}}">
									<p class="solutionCategory-p" @click="solution=false">锐捷三擎云桌面解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==2?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:7}}">
									<p class="solutionCategory-p" @click="solution=false">等级保护2.0解决方案</p>
									</router-link>
								</div>
								<div class="second-solutionCategory-con" :style="solutionCategory==3?'opacity:1;display:inline-block;':'opacity:0;display: none;'">
									<router-link :to="{path:'minimalistSolution',query:{num:5}}">
									<p class="solutionCategory-p" @click="solution=false">锐捷轻云解决方案</p>
									</router-link>
								</div>
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
		</div>
		
		<div class="productCategory" :style="productCategory?'opacity:1':'opacity:0;display: none;'" @mouseover="productCategory=true" @mouseout="productCategory=false">
			<Row>
				<Col span="4" style="background: #ffffff;"></Col>
				<Col span="20">
					<Row>
						<Col span="4">
							<div class="chemicalMaterials">
								  <p :style="stairCategory?'color: #009bff;':''" @click="stairCategory=true">自研产品</p>
								<p class="chemicalMaterials-p" :style="stairCategory?'':'color: #009bff;'" @click="stairCategory=false">代理产品</p>
							</div>
						</Col>
						<Col span="5">
							<div class="second-productCategory" :style="stairCategory?'opacity:1':'opacity:0;display: none;'">
								<div class="second-productCategory1">
									<span >综合运维</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:0}}">
									<p @click="productCategory=false">综合运维管理系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:23}}">
									<p @click="productCategory=false">IT自动化监测系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:24}}">
									<p @click="productCategory=false">运维服务管理系统</p>
									</router-link>
								</div>
							</div>
							<div class="second-productCategory" :style="stairCategory?'opacity:0;display: none;':'opacity:1'">
								<div class="second-productCategory1">
									<span>硬件产品</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:5}}">
									<p @click="productCategory=false">清华同方系列</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:9}}">
									<p @click="productCategory=false">锐捷系列</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:20}}">
									<p @click="productCategory=false">MG（户内小间距产品）</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:21}}">
									<p @click="productCategory=false">VED(室内产品系列)</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:22}}">
									<p @click="productCategory=false">TVF</p>
									</router-link>
								</div>
								
							</div>
						</Col>
						<Col span="5">
							<div class="second-productCategory" :style="stairCategory?'opacity:1':'opacity:0;display: none;'">
								<div class="second-productCategory1">
									<span>物联网</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:1}}">
									<p @click="productCategory=false">物联网网关</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:2}}">
									<p @click="productCategory=false">物联网综合管理平台</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:26}}">
									<p @click="productCategory=false">动力环境监测系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:27}}">
									<p @click="productCategory=false">边缘计算网关</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:28}}">
									<p @click="productCategory=false">视频网关</p>
									</router-link>
								</div>
							</div>
							<div class="second-productCategory" :style="stairCategory?'opacity:0;display: none;':'opacity:1;'">
								<div class="second-productCategory1">
									<span>软件产品</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:6}}">
									<p @click="productCategory=false">麒麟软件</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:7}}">
									<p @click="productCategory=false">WPS Office</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:8}}">
									<p @click="productCategory=false">同有科技系列</p>
									</router-link>
								</div>
							</div>
						</Col>
						<Col span="5">
							<div class="second-productCategory" :style="stairCategory?'opacity:1':'opacity:0;display: none;'">
								<div class="second-productCategory1">
									<span>智慧中台</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:3}}">
									<p @click="productCategory=false">应用集成管理平台</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:4}}">
									<p @click="productCategory=false">数据中台</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:25}}">
									<p @click="productCategory=false">基础管理平台</p>
									</router-link>
								</div>
							</div>
							<div class="second-productCategory" :style="stairCategory?'opacity:0;display: none;':'opacity:1;'">
								<div class="second-productCategory1">
									<span>网络安全</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:10}}">
									<p @click="productCategory=false">新一代智慧防火墙</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:11}}">
									<p @click="productCategory=false">上网行为管理与审计系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:12}}">
									<p @click="productCategory=false">终端安全管理系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:13}}">
									<p @click="productCategory=false">威胁检测与分析系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:14}}">
									<p @click="productCategory=false">安全接入网关系统（SSL VPN）</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:15}}">
									<p @click="productCategory=false">统一服务器安全管理系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:16}}">
									<p @click="productCategory=false">服务器安全管理系统（云锁）</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:17}}">
									<p @click="productCategory=false">安全SD-WAN</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:18}}">
									<p @click="productCategory=false">数据库审计与防护系统</p>
									</router-link>
									<router-link :to="{path:'compProduct',query:{num:19}}">
									<p @click="productCategory=false">运维安全管理与审计系统（堡垒机）</p>
									</router-link>
								</div>
							</div>
						</Col>
						<Col span="5">
							<div class="second-productCategory" :style="stairCategory?'opacity:1':'opacity:0;display: none;'">
								<div class="second-productCategory1">
									<span>智慧城市</span>
								</div>
								<div class="second-productCategory1-con">
									<router-link :to="{path:'compProduct',query:{num:29}}">
									<p @click="productCategory=false">智慧园区</p>
									</router-link>
								</div>
							</div>
						</Col>

					</Row>
				</Col>

			</Row>
		</div>
  </div>


</template>

<script>
    export default {
            data () {
                return {
                    theme1: 'light',
                    index: sessionStorage.getItem('index')||'1',
					productCategory:false,
					solution:false,
					solutionCategory:1,
					stairCategory:true,
                }
            },
            props:{
              scroll:Boolean
            },
            mounted(){
              window.addEventListener('setItem', ()=> {
                this.index = sessionStorage.getItem('index');
              })
            },
			methods:{
				goIndex(index){
				  this.resetSetItem('index',index);
				}
			}
        }
</script>

<style lang="less">
   .ivu-menu-submenu-title span>i, .ivu-menu-submenu-title>i {
    display: none ;
  }
  .ivu-menu-horizontal.ivu-menu-light:after {
    height: 0;
  }
 .top-menu-content{
	 display: inline-block;
  }
  .my-top-menu{
   /* background: #FFFFFF; */
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   background: #FFFFFF;
   z-index: 1000;
   .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu{
     color: #333333 !important;
   }
  }
	.productCategory{
		width: 100%;
		height: 100%;
		background-color: rgb(245,245,245);
		box-shadow: #eaeff5 0px -2px 2px;
	}
	.chemicalMaterials{
		text-align: center;
		background: #ffffff;
		padding-top: 0.5rem;
		height: 100%;
		padding-bottom: 1.5rem;
	}
	.chemicalMaterials p{
		cursor: pointer;
	}
	.chemicalMaterials-p{
		margin-top: 0.2rem;
	}
	.second-productCategory{
		padding-left: 0.5rem;
		padding-top: 0.5rem;
	}
	.second-productCategory1{
		padding-bottom: 0.1rem;
		border-bottom: #e0e6ec 1.5px solid;
	}
	.second-productCategory1 span{
		color: #333333;
		font-size: 14px;
		font-weight: bold;
	}
	.second-productCategory1-con p{
		margin-top: 0.1rem;
		color: #666666;
	}
	.second-productCategory1-con p:hover{
		color: #009bff;
	}
	.second-solutionCategory-con{
		width:30%;
		text-align:left;
	}
	.second-solutionCategory-con p{
		color: #666666;
	}
	.solutionCategory-p{
		margin-top: 0.1rem;
	}
	.second-solutionCategory-con p:hover{
		color: #009bff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/components/MenuBar.vue